<template>
  <div v-editable="blok" class="summary-blok one-two alternate shopify-simple-product-list">
    <div v-if="!productDetailData">
      <div class="summary-card" :key="index" v-for="(product,index) in products">
        <div class="copy">
          <div class="copy-container text-left">
            <h4 class="title">{{ product.title }}</h4>
            <!-- <div class="copy-text text-left" v-html="product.descriptionHtml"></div> -->
            <div class="copy-text">
              <b>
                <span class="h3" v-mny="{ input: product.variants[0].price, currency: 'GBP' }"></span>
              </b>
            </div>
            <div class="cta">
              <product-cta-button
                :showDetailsButton="true"
                :productId="product.variants[0].id"
                @descreaseBasketItem="descreaseBasketItem"
                @increaseBasketItem="increaseBasketItem"
                @removeFromBasket="removeFromBasket"
                @addToBasket="addProductToBasket(product,index)"
                @showProductDetails="onShowProductDetails(product.id)"
              ></product-cta-button>
            </div>
          </div>
        </div>
        <div
          class="image dots-bottom__center__large"
          :style="`background-image: url(${product.images[0] ? product.images[0].src : ''})`"
        ></div>
      </div>
    </div>
    <div v-else>
      <div class="summary-card">
        <div class="copy pr-md-2 d-flex">
          <div class="copy-container text-left d-flex flex-column align-self-start pr-md-2">
            <h4 class="title">{{ productDetailData.title }}</h4>
            <div class="copy-text text-left" v-html="productDetailData.descriptionHtml"></div>
            <div class="copy-text">
              <b>
                <span
                  class="h3"
                  v-mny="{ input: productDetailData.variants[0].price, currency: 'GBP' }"
                ></span>
              </b>
            </div>
            <div class="cta">
              <product-cta-button
                :showDetailsButton="false"
                :productId="productDetailData.variants[0].id"
                @descreaseBasketItem="descreaseBasketItem"
                @increaseBasketItem="increaseBasketItem"
                @removeFromBasket="removeFromBasket"
                @addToBasket="addProductToBasket(productDetailData,index)"
                @showProductDetails="onShowProductDetails(productDetailData.id)"
              ></product-cta-button>
            </div>
          </div>
        </div>
        <div
          class="image dots-bottom__center__large"
          :style="`background-image: url(${productDetailData.images[0] ? productDetailData.images[0].src : ''})`"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapState } from "vuex";
import shopifyService from "../../../service/shopifyService";

import ProductCtaButton from "./ProductCtaButton";

export default {
  name: "shopify-product-list",
  props: {
    products: Array,
    blok: Object
  },
  data: () => {
    return {
      productDetailData: null
    }
  },
  components: {
    ProductCtaButton
  },
  watch: {
    products: function(val) {
      const viewLogging = val.map( (v,i) => {
        return {
          "id": v.id,
          "name": v.title,
          "list_name": v.title,
          "category": v.productType,
          "variant": v.variants[0].sku,
          "list_position": i,
          "price": v.variants[0].price  
        }
      });
      this.trackProductListing(viewLogging);
    },
    urlProductId: function(val) {
      if(val) {
        this.requestProductData();
      } else {
        this.productDetailData = null;
      }
    }
  },
  computed: {
    urlProductId: {
      get() {
        return this.$route.query.product_id;
      }
    }
  },
  mounted: function() {
    if(this.urlProductId) {
      this.requestProductData();
    }
  },
  methods: {
    ...mapActions("analytics", ["trackProductListing"]),
    ...mapActions("shopify", ["fetchProduct"]),
    addProductToBasket: function(product, index) {
      this.$emit("addProductToBasket", product.variants[0]);
    },
    removeFromBasket: function(lineItem) {
      this.$emit("removeFromBasket", lineItem);
    },
    descreaseBasketItem: function(lineItem) {
      this.$emit("descreaseBasketItem", lineItem);
    },
    increaseBasketItem: function(lineItem) {
      this.$emit("increaseBasketItem", lineItem);
    },
    onShowProductDetails: function(urlProductId) {
      this.$router.push({ query: { product_id: urlProductId }})
    },
    requestProductData: function() {
      this.fetchProduct(this.urlProductId).then( d => {
        this.productDetailData = d;
      });
    }
  }
};
</script>
